import React from 'react';

import CommercialIcon from '@mui/icons-material/BusinessRounded';
import MultiFamilyIcon from '@mui/icons-material/HomeRounded';
import DashIcon from '@mui/icons-material/Remove';
import MixedUseIcon from '@mui/icons-material/StoreRounded';
import { Tooltip } from '@mui/material';
import { PropertyTypes } from 'types/jobs';

const iconColor = 'rgba(0, 0, 0, 0.54)';
const iconStyles = {
  fill: iconColor,
  width: '35px',
  height: '35px',
  borderRadius: '48px',
};

type PropertyTypeProps = {
  propertyType?: PropertyTypes;
};

const PropertyTypeIcon = ({ propertyType }: PropertyTypeProps) => {
  const getIcon = () => {
    switch (propertyType) {
      case 'Residential (Non-Commercial)':
      case 'Multifamily': {
        return <MultiFamilyIcon sx={iconStyles} />;
      }
      case 'Mixed-use':
      case 'Community Facility':
      case 'Mixed Use (Residential and Commercial)': {
        return <MixedUseIcon sx={iconStyles} />;
      }
      case 'Commercial':
      case 'Industrial':
      case 'Office':
      case 'Retail': {
        return <CommercialIcon sx={iconStyles} />;
      }
      default: {
        return <DashIcon sx={iconStyles} />;
      }
    }
  };

  return (
    <Tooltip placement="top" title={propertyType}>
      {getIcon()}
    </Tooltip>
  );
};

export default PropertyTypeIcon;
